module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "my-attention"
  }, [_c('tab-header', {
    attrs: {
      "tabList": _vm.attenTionTabList,
      "tabName": _vm.tabName,
      "isSort": false,
      "isSelf": _vm.isSelf
    },
    on: {
      "getTabName": _vm.getTabName
    }
  }), _vm._v(" "), _c('section', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "attenTion-content"
  }, [(_vm.attenTionList.length) ? _c('ul', {
    staticClass: "attenTion-list"
  }, _vm._l((_vm.attenTionList), function(attention, index) {
    return _c('li', {
      key: index,
      staticClass: "attenTion-item"
    }, [_c('div', {
      staticClass: "attenTion-left"
    }, [(attention.avatar.substr(0, 1) === '?') ? _c('img', {
      staticClass: "avatar",
      attrs: {
        "src": require("../../images/personal_center/avatar_default.png")
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.goHomePage(attention.user_id)
        }
      }
    }) : _c('img', {
      staticClass: "avatar",
      attrs: {
        "src": attention.avatar,
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.goHomePage(attention.user_id)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "user-info"
    }, [_c('p', {
      staticClass: "user-top",
      on: {
        "click": function($event) {
          return _vm.goHomePage(attention.user_id)
        }
      }
    }, [_c('span', {
      staticClass: "nick-name"
    }, [_vm._v(_vm._s(attention.nick_name))]), _vm._v(" "), (_vm.isLogin && attention.is_followed === null) ? _c('span', {
      staticClass: "is-self"
    }, [_vm._v("我自己")]) : _vm._e(), _vm._v(" "), (attention.is_official) ? _c('el-tooltip', {
      attrs: {
        "effect": "light",
        "content": "蓝鲸智云官方",
        "placement": "right"
      }
    }, [_c('svg', {
      staticStyle: {
        "width": "20px",
        "height": "20px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-lanjingguanfang"
      }
    })])]) : _vm._e(), _vm._v(" "), (attention.is_vip) ? _c('el-tooltip', {
      attrs: {
        "effect": "light",
        "content": "核心用户",
        "placement": "right"
      }
    }, [_c('span', {
      staticClass: "icon-vipuser",
      staticStyle: {
        "margin-left": "2px"
      }
    })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "statistics-info"
    }, [_c('p', [_c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(attention.qa_num))]), _vm._v("个问题")]), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(attention.comment_num))]), _vm._v("个回答")]), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(attention.article_num))]), _vm._v("篇文章")]), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(attention.saas_num))]), _vm._v("个作品")])])])]), _vm._v(" "), _c('div', {
      staticClass: "attenTion-right"
    }, [_c('p', {
      staticClass: "follow-time"
    }, [_vm._v("\n                        关注时间：\n                        "), _c('span', [_vm._v(_vm._s(attention.follow_time || '--'))])]), _vm._v(" "), (!_vm.isLogin || attention.is_followed !== null) ? _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": "取消关注",
        "disabled": !((_vm.isSelf ? _vm.tabName === 'follow_me' : true) && attention.is_mutual_follow),
        "placement": "top"
      }
    }, [_c('p', {
      class: ['attenTion-btn', attention.className],
      on: {
        "click": function($event) {
          return _vm.handleToggleAttention(attention)
        }
      }
    }, [(attention.className.indexOf('follow-me') !== -1) ? [(attention.is_mutual_follow) ? _c('img', {
      staticClass: "sort-img",
      attrs: {
        "src": require("../../images/personal_center/sort.png"),
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "add-img",
      attrs: {
        "src": require("../../images/personal_center/plus-line.png"),
        "alt": ""
      }
    })] : _vm._e(), _vm._v(" "), (_vm.isSelf) ? [_vm._v("\n                                " + _vm._s(!_vm.isLogin ? '关注' : attention.className === 'my-follow' ? '取消关注' : attention.is_mutual_follow ? '互相关注' : '关注') + "\n                            ")] : [_vm._v("\n                                " + _vm._s(attention.is_mutual_follow ?
      '互相关注' :
      attention.is_followed ?
      '取消关注' :
      '关注') + "\n                            ")]], 2)]) : _vm._e()], 1)])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.attenTionList.length && !_vm.isLoading),
      expression: "!attenTionList.length && !isLoading"
    }],
    staticClass: "content-empty"
  }, [_c('img', {
    attrs: {
      "src": require("../../images/personal_center/data-null.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂无数据")])]), _vm._v(" "), (_vm.isMoreLoading || _vm.attenTionList.length > 10) ? _c('div', {
    staticClass: "load-more"
  }, [(_vm.isMoreLoading) ? _c('img', {
    attrs: {
      "alt": "loadding",
      "src": require("../../images/common/loading_2_24x24.gif")
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.totalPage === _vm.curPage ? '没有更多内容了' : '显示更多'))])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-55a15d42!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal_center/my_attention.vue
// module id = 0XL2
// module chunks = 15